import { Controller } from "@hotwired/stimulus"
import ApexCharts from "apexcharts"

export default class extends Controller {
  static values = { counts: Object }

  connect() {
    const counts = this.countsValue || {}
    const dates  = Object.keys(counts).sort()
    const values = dates.map((d) => counts[d])

    if (dates.length === 0) return

    const options = {
      chart: {
        type: "bar",
        height: 200,
        toolbar: { show: false },
        fontFamily: "'Neue Haas Grotesk Text Pro','DM Sans',sans-serif"
      },
      series: [{ name: "Chats", data: values }],
      xaxis: {
        categories: dates,
        labels: { style: { colors: "#9CA3AF", fontSize: "11px" }, rotate: -45 },
        axisBorder: { color: "#E5E7EB" }
      },
      yaxis: {
        labels: { style: { colors: "#9CA3AF", fontSize: "11px" } }
      },
      colors: ["#734CE0"],
      plotOptions: { bar: { borderRadius: 3, columnWidth: "60%" } },
      grid: { borderColor: "#F0F1F3", strokeDashArray: 3 },
      dataLabels: { enabled: false },
      tooltip: { y: { formatter: (v) => `${v} chats` } }
    }

    this.chart = new ApexCharts(this.element, options)
    this.chart.render()
  }

  disconnect() {
    if (this.chart) this.chart.destroy()
  }
}
